import { z } from 'zod';

export const socialLinkRowSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  href: z.string().min(1),
  iconName: z.string().min(1),
  sortOrder: z.number().int(),
  visible: z.boolean(),
});

export const socialLinkInsertSchema = z.object({
  id: z.string().min(1).optional(),
  label: z.string().min(1),
  href: z.string().min(1),
  iconName: z.string().min(1),
  sortOrder: z.number().int().optional(),
  visible: z.boolean().optional(),
});

export const socialLinkUpdateSchema = socialLinkInsertSchema.partial();

export type SocialLinkRow = z.infer<typeof socialLinkRowSchema>;
export type SocialLinkInsert = z.input<typeof socialLinkInsertSchema>;
export type SocialLinkUpdate = z.input<typeof socialLinkUpdateSchema>;
